module.exports = "\n<app-header-bar></app-header-bar>\n\n <router-outlet></router-outlet>\n\n<app-footer-bar></app-footer-bar>\n"


//////////////////
// WEBPACK FOOTER
// D:/deliverproject/eatasiafood/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main